import './index.scss';
import create_hidden_input from "../../module/create_hidden_input/create_hidden_input";



let filter_searching = $(`.filter_searching`).select2({
    dropdownAutoWidth: true,
    width: "resolve",
    minimumResultsForSearch: -1,
});

let filter_category = $(`.filter_category`).select2({
    dropdownAutoWidth: true,
    width: "resolve",
    minimumResultsForSearch: -1,
});

let filter_sorting = $(`.filter_sorting`).select2({
    dropdownAutoWidth: true,
    width: "resolve",
    minimumResultsForSearch: -1,
});



function origin_url(pagination_click) {
    let page_number;
    let current_url;
    let array_url = [];

    let filter_searching = $('.filter_searching').val();
    let filter_category = $('.filter_category').val();
    let filter_sorting = $('.filter_sorting').val();

    if (pagination_click) {
        page_number = $(pagination_click).attr('data-href');

    } else {
        page_number = 'page_number=1';
    }

    // array_url.push(filter_searching);
    // array_url.push(filter_category);
    array_url.push(filter_sorting);
    array_url.push(page_number);

    current_url = array_url.join('&');
    window.location = `?${current_url}`;
}

$('.filter_sorting').on('select2:select', function (e) {
    origin_url(false);
});


$('.filter_searching').on('select2:select', function (e) {
    let option = $(e.target).find(":selected");
    let url = $(option).attr('data-url');
    window.location = url;
});

$('.filter_category').on('select2:select', function (e) {
    let option = $(e.target).find(":selected");
    let url = $(option).attr('data-url');
    window.location = url;
});

// $('.filter_search_label').on('click', function () {
//     origin_url(false);
// })

$('.pagination_link').on('click', function () {
    origin_url(this);
})













let check_select_click = true;
$('.filter_category_name').on('click', function () {

    if (check_select_click) {
        $('.filter_category').select2('open');
        check_select_click = false;

    } else {
        $('.filter_category').select2('close');
        check_select_click = true;

    }

});